import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Row, Col, Spinner } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ImageUploadBox from "../../components/ImageUploadBox";

function AddBanner() {
  const baseURL = process.env.REACT_APP_API_URL;
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("profileToken");

  const initialState = { brand_id: "" };

  const [formData, setFormData] = useState(initialState);
  const [imageFile, setImageFile] = useState(null); 
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${baseURL}/brand/list`, {
          headers: { "x-access-token": token || "" },
        });
        setBrands(data?.status && Array.isArray(data?.result) ? data.result : []);
      } catch (err) {
        console.error("❌ Error fetching brands:", err);
        setBrands([]);
      }
    })();
  }, [baseURL, token]);
  useEffect(() => {
    if (!id) return;

    (async () => {
      try {
        const { data } = await axios.get(`${baseURL}/banner/${id}`, {
          headers: { "x-access-token": token || "" },
        });

        if (data?.status && data?.result) {
          const banner = data.result;

          setFormData({
            brand_id: banner.brand_id ? String(banner.brand_id) : "",
          });

          setImageFile(banner.image || null); 
        } else {
          setFormData(initialState);
          setImageFile(null);
        }
      } catch (err) {
        console.error("❌ Error fetching banner:", err);
        Swal.fire("Error", "Failed to fetch banner details", "error");
      }
    })();
  }, [id]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleImageChange = (e) => {
    setImageFile(e.target.files?.[0] || null);
  };

  const handleReset = () => {
    setFormData(initialState);
    setImageFile(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!imageFile && !id) {
      Swal.fire("Error", "Banner image is required", "error");
      return;
    }

    try {
      setLoading(true);

      const data = new FormData();

      if (formData.brand_id) data.append("brand_id", formData.brand_id);

      if (imageFile && typeof imageFile !== "string") {
        data.append("image", imageFile);
      }

      const headers = {
        "Content-Type": "multipart/form-data",
        "x-access-token": token || "",
      };

      if (id) {
        await axios.put(`${baseURL}/banner/update/${id}`, data, { headers });
        Swal.fire("Success", "✅ Banner updated successfully!", "success");
      } else {
        await axios.post(`${baseURL}/banner/add`, data, { headers });
        Swal.fire("Success", "✅ Banner added successfully!", "success");
      }

      navigate("/banner-list");
    } catch (err) {
      console.error("❌ Error saving banner:", err);
      Swal.fire("Error", err.response?.data?.message || "❌ Failed to save banner", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-4">
      <h3 className="fw-bold text-center mb-4 text-success">
        {id ? "Update Banner" : "Add New Banner"}
      </h3>

      <form onSubmit={handleSubmit}>
        <Row className="g-4">
          <Col xs={12} md={12}>
            <div className="border border-success rounded-4 p-4">
              <ImageUploadBox
                id="bannerInput"
                label="Banner image"
                value={imageFile}
                onChange={handleImageChange}
                baseURL={baseURL}
                required={!id}
                isEdit={!!id}
                variant="dashed"
                height={350}
              />

              <div className="mb-3 mt-3">
                <label htmlFor="brand_id" className="form-label">
                  Select Brand
                </label>

                <select
                  id="brand_id"
                  className="form-select"
                  value={formData.brand_id}
                  onChange={handleChange}
                >
                  <option value="">Select Brand</option>
                  {brands.map((b) => (
                    <option key={b.id} value={b.id}>
                      {b.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="d-flex justify-content-end gap-2">
                <Button
                  variant="outline-dark"
                  className="rounded-pill px-4"
                  onClick={handleReset}
                  type="button"
                >
                  Reset
                </Button>

                <Button
                  variant="success"
                  className="rounded-pill px-4"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <Spinner size="sm" /> : id ? "Update" : "Save"}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </form>
    </div>
  );
}

export default AddBanner;
